<template>
  <VModalWidget :dismiss="dismiss" :submit="doSubmit" :submitting="submitting" :submitTitle="this.$t('create')">
    <template slot="title"> {{ $t('labels.new') }} {{ $t(`labels.${entityType}`) }} </template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          v-model.trim="form.display"
          :label="$t('labels.displayName')"
          :error-messages="nameErrors"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
          v-on:keyup.enter="doSubmit"
        />
        <v-text-field v-model.trim="form.description" :label="$t('labels.description')" v-on:keyup.enter="doSubmit" />
        <TagsLine :selection="tags" :update-selection="updateTags" :can-edit="true" />
      </v-form>
    </template>
  </VModalWidget>
</template>

<script>
import { VModalWidget, FormErrors } from '@argon/app/components'
import { TagsLine } from '@argon/evo/addons/components'
import { NewEntityMixin } from '../mixins'
export default {
  name: 'NewEntitydWidget',
  mixins: [NewEntityMixin],
  components: {
    VModalWidget,
    FormErrors,
    TagsLine
  }
}
</script>

<style scoped>
.v-progress-linear {
  margin: 0;
}
</style>
